module.exports = require('./helpers/bundle-url').getBundleURL('32lH7') + "logo.c51670a8.svg";